export function LiquidLoader({ text = "Loading" }) {
  return (
    <div className="liquid-loader">
      <div className="loader-track">
        <div className="liquid-fill" />
      </div>
      <div className="loading-text">
        {text}
        <span className="dot">.</span>
        <span className="dot">.</span>
        <span className="dot">.</span>
      </div>
    </div>
  );
}
